// @flow
import React, {useMemo} from 'react';
import ReactDOM from 'react-dom';
import {matchPath} from 'react-router';
import {BrowserRouter as Router} from 'react-router-dom';
import Cookies from 'js-cookie';
import './otel-setup';
import './polyfills';
import {setupAxios} from '@api/setup';
import {setMerchantID, setUserToken} from '@reducers/disputes/actions/settings';
import {resolveMerchantId} from '@utils/merchant';
import AppWithDisputesRoutes from './appWithDisputesRoutes';
import DevLayout from './dev';
import getStore from './store';
import setupLocales from './utils/setup/locale';
// $FlowFixMe
import '@xsolla/uikit/lib/icons.css';
import './css/app.css';

const useSetup = () =>
  useMemo(() => {
    const match = matchPath(location.pathname, {
      path: '/:merchant_id(\\d+)'
    });

    const token = process.env.DEFAULT_TOKEN || '';
    const merchant_id = resolveMerchantId(
      match?.params?.merchant_id || Number(process.env.DEFAULT_MERCHANT_ID) || null,
      token
    );
    const project_id = match?.params?.project_id || Number(process.env.DEFAULT_PROJECT_ID) || null;
    const store = getStore({});
    store.dispatch(setUserToken(token));
    merchant_id && store.dispatch(setMerchantID(merchant_id));

    setupLocales(store.dispatch, store.getState);
    setupAxios(token);
    return {store, merchant_id, project_id};
  }, []);

const StandaloneApp = () => {
  const {store, merchant_id, project_id} = useSetup();
  const currentLocale = Cookies.get('sb-pa-locale') || 'en';

  return (
    <Router>
      <DevLayout project_id={project_id} merchant_id={merchant_id}>
        {/* <DevLayout merchant_id={merchant_id} project_id={project_id}> */}
        <AppWithDisputesRoutes
          locale={currentLocale}
          store={store}
          project_id={project_id}
          merchant_id={merchant_id}
        />
        {/* </DevLayout> */}
      </DevLayout>
    </Router>
  );
};

// $FlowFixMe
ReactDOM.render(<StandaloneApp />, document.getElementById('app'));
